// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentModel {
    static getAttributeTypeMap() {
        return EnrollmentModel.attributeTypeMap;
    }
}
EnrollmentModel.discriminator = undefined;
EnrollmentModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "paymentTypeCode",
        "baseName": "paymentTypeCode",
        "type": "string"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "EnrollmentEligibilityModel"
    },
    {
        "name": "updateCaseIds",
        "baseName": "updateCaseIds",
        "type": "Array<number>"
    },
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": "Array<EnrollmentMemberNumberModel>"
    },
    {
        "name": "linkedEntities",
        "baseName": "linkedEntities",
        "type": "EnrollmentCaseRelationshipsModel"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "updatedBy",
        "baseName": "updatedBy",
        "type": "number"
    },
    {
        "name": "updatedOn",
        "baseName": "updatedOn",
        "type": "Date"
    },
    {
        "name": "caseSourceId",
        "baseName": "caseSourceId",
        "type": "number"
    },
    {
        "name": "maxBenefit",
        "baseName": "maxBenefit",
        "type": "string"
    },
    {
        "name": "maxBenefitAmount",
        "baseName": "maxBenefitAmount",
        "type": "number"
    },
    {
        "name": "untrackedBenefit",
        "baseName": "untrackedBenefit",
        "type": "boolean"
    },
    {
        "name": "householdSize",
        "baseName": "householdSize",
        "type": "number"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "claimEligibilityDate",
        "baseName": "claimEligibilityDate",
        "type": "Date"
    },
    {
        "name": "reenrollmentEligibilityDate",
        "baseName": "reenrollmentEligibilityDate",
        "type": "Date"
    },
    {
        "name": "paymentType",
        "baseName": "paymentType",
        "type": "number"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    }
];
//# sourceMappingURL=enrollmentModel.js.map